import 'css-chunksrc/client/scenes/projectResourceGroupRemoval/styles.scss';export default {
  "header": "_header_2irec_1",
  "group": "_group_2irec_5",
  "text": "_text_2irec_9",
  "name": "_name_2irec_14",
  "main": "_main_2irec_20",
  "buttons": "_buttons_2irec_27"
};